export default from './DesktopCalculationsResult';



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/components/DesktopCalculationsResult/index.js